import { render, staticRenderFns } from "./main.vue?vue&type=template&id=59d8a5a0&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59d8a5a0')) {
      api.createRecord('59d8a5a0', component.options)
    } else {
      api.reload('59d8a5a0', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=59d8a5a0&", function () {
      api.rerender('59d8a5a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/search/src/main.vue"
export default component.exports